export const API_HOST = 'https://api.ruguoapp.com'
export const JIKE_WEB_MOBILE_HOST = 'https://m.okjike.com'
export const JIKE_WEB_HOST = 'https://web.okjike.com'
export const JIKE_SOCKET_HOST = 'wss://jike-io.ruguoapp.com'
